export default __webpack_public_path__ + "images/38fc8867c632fd819462774450d83ff4.png";